import { DecimalInput, NumberInput } from '@framework/form';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { getWidgetProps } from '../common/util/getWidgetProps';
import type { INumberWidget } from './INumberWidget';

export interface INumberWidgetComponentProps
  extends IWidgetComponentProps<INumberWidget> {}

export function NumberWidgetComponent(props: INumberWidgetComponentProps) {
  const options = getWidgetProps(props);

  const valueRange = props.widget.rules?.valueRange;
  const positive = props.widget.rules?.positive?.value;
  const integer = props.widget.rules?.integer?.value;
  const decimalPlaces = props.widget.decimalSize ?? undefined;

  const valueRangeMin = valueRange?.min ?? (positive ? 0 : undefined);

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      {decimalPlaces || !integer ? (
        <DecimalInput
          readOnly={props.readonly}
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          tabIndex={options.preview ? -1 : undefined}
          decimalPlaces={decimalPlaces}
          asNumber
        />
      ) : (
        <NumberInput
          readOnly={props.readonly}
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          // Il minimo e il massimo creano dei bug in fase di scrittura.
          // min={valueRangeMin ?? undefined}
          // max={valueRange?.max ?? undefined}
          step={integer ? 1 : undefined}
          tabIndex={options.preview ? -1 : undefined}
        />
      )}
    </ConfigFormItem>
  );
}
